// react imports
import React, { Component } from "react"

// package imports
import { Col, Container, Row, Image, Button } from "react-bootstrap"
import { observer } from "mobx-react"
import { toJS } from "mobx"
import moment from "moment"

// project imports
import QmsDetailsPageTabComponent from "modules/qms-flow/components/qms-details-page-tab-component/QmsDetailsPageTabComponent"
import CurrentCoverageCard from "modules/solution/components/current-coverage-card/CurrentCoverageCard"
import QmsDetailsPageStore from "./QmsDetailsPageStore"
import SolutionBenefitsCard from "modules/solution/components/solution-benefits-card/SolutionBenefitsCard"
import SolutionScreenSingleLaCard from "modules/solution/components/solution-screen-single-la-card/SolutionScreenSingleLaCard"
import SolutionScreenMulipleLaCard from "modules/solution/components/solution-screen-multiple-la-card/SolutionScreenMulipleLaCard"
import PolicyTimlineTable from "modules/solution/components/policy-timeline-table/PolicyTimelineTable"
import UnderlyingCard from "modules/solution/components/underlying-card/UnderlyingCard"
import * as Constants from "constants/Constants";
import Utils from 'modules/solution/utils';
import ProductConstants from "constants/ProductConstants"
import { NextButton } from "components"
import * as images from "constants/Images";
import StartApplicationModal from "../start-application-modal/StartApplicationModal"
import QmsStorageKeys from "constants/QmsStorageKeys"
import SolutionStore from "modules/solution/store/SolutionStore"
import StorageKeys from "constants/StorageKeys"
import UiButton from "components/ui/button/Button"
import ProductNames from "constants/ProductNames"

import "modules/solution/solution.css"
import AuthStore from "modules/login/store/AuthStore"
import { EDIT_QUOTE, SHARE_ON_WHATSAPP, START_APPLICATION } from "constants/UserClicksConstant"
import SharePdf from "components/ui/share-pdf-via-whatsapp/SharePdf"
import NewPolicyTimelineTableMultipleLa from "modules/solution/components/new-policy-timeline-table-multiple-la/NewPolicyTimelineTableMultipleLa"
import isObjectEmpty from "utils/isObjectEmpty"

const QmsDetailsPage = observer(
	class QmsDetailsPage extends Component {
		constructor(props) {
			super(props)
			this.state = {
				tabList: [],
				selectedTabIndex: "0",
				seletedTabData: {},
				showStartApplicationModal: false,
				disbledStartApplication: false,
				leadRefIdValue: "",
				startAppLabel: { show_massage: false, lead_ref_id: "" }

			}
			this.setSelectedTabIndex = this.setSelectedTabIndex.bind(this)
			this.onSubmitLeadRefId = this.onSubmitLeadRefId.bind(this)
		}

		async componentDidMount() {
			window.scrollTo(0, 0)
			let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
			let agentData = this.props.location.state?.agent_details
			let proposerId = this.props.location.state?.proposerId
			await QmsDetailsPageStore.saveAgentDetails(agentData)
			await SolutionStore.fetchSolutionData(proposerId)
			QmsDetailsPageStore.updateSelectedTabData(SolutionStore.user_list_data[0])
			this.setState({ seletedTabData: SolutionStore.user_list_data[0], tabList: SolutionStore.user_list_data })
			QmsDetailsPageStore.solutionId = SolutionStore.user_list_data[0]?.solution_id
			QmsDetailsPageStore.getSolutionTimeLinedata(proposerId)
			await QmsDetailsPageStore.checkUlipTrainingFlag(this.props.location.state?.journeyId)
			await QmsDetailsPageStore.getWhatsAppMessageData(this.props.location.state?.journeyId)
			if (channel_code === "DIS") {
				this.setState({ disbledStartApplication: true })
			}

		}

		setSelectedTabIndex(tabIndex) {
			this.setState({ selectedTabIndex: tabIndex })
		}

		componentDidUpdate(prevProps, prevState) {
			let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
			if (prevState.selectedTabIndex != this.state.selectedTabIndex) {
				SolutionStore.user_list_data.forEach((item, index) => {
					if (index.toString() === this.state.selectedTabIndex) {
						this.setState({ seletedTabData: item })
						QmsDetailsPageStore.updateSelectedTabData(item)
						QmsDetailsPageStore.solutionId = item.solution_id
					}
				})

			}

			// if (prevState.leadRefIdValue != this.state.leadRefIdValue && this.state.leadRefIdValue.length === 0 && channel_code === "DIS") {
			// 	this.setState({ disbledStartApplication: true })
			// 	// this.setState({ startAppLabel: false })
			// 	this.setState(prevState => ({
			// 		startAppLabel: {
			// 			...prevState.startAppLabel,
			// 			show_massage: false
			// 		}
			// 	}));
			// }
		}

		laNameFunction(singleLA) {
			let { la_salutation, la_name, la_family_member_type } = singleLA
			// if (la_salutation && la_name) { return `${la_salutation} ${la_name}` }
			if (la_name) { return `${la_name}` }
			return la_family_member_type
		}

		onEditQuote() {
			//! for save user clicks
			AuthStore.saveUserClicks(EDIT_QUOTE)
			localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false);
			this.props.history.push(`/customization`)
		}

		downloadSampleBi() {
			let familyProductDetailsIds = SolutionStore.fetchFamilyProductDetailsIds(this.state.seletedTabData?.coverage)
			SolutionStore.downloadSampleBiPdf(familyProductDetailsIds)
		}

		checkPdfData() {

			if (QmsDetailsPageStore?.sharePdfData?.length <= 1) {
				//!for save user clicks
				AuthStore.saveUserClicks(SHARE_ON_WHATSAPP)

				let url = QmsDetailsPageStore.sharePdfData[0]?.whatsapp_message
				// let mobileNumber = +919757225774
				let mobileNumber = QmsDetailsPageStore.sharePdfData[0]?.mobile_number
				window.open(`https://api.whatsapp.com/send?phone=${mobileNumber}&text=${encodeURIComponent(url)}`)
			} else {
				QmsDetailsPageStore.setshowSharePdfmodal(true)
			}

		}

		showDownloadSampleBiBtn() {
			let asbOption = false
			if (this.state.seletedTabData?.productList.length > 0) {
				let productData = this.state.seletedTabData?.productList.filter((item) => Number(item.productId) === Number(ProductNames.flexiSavingsPlan))
				if (productData.length > 0) {
					productData.forEach((data) => {
						if (data.inputString.find(item => item.Key === '@DISPLAY_PR_OPTION_4').Value === 'Yes' && !asbOption) {
							asbOption = true
						}
					})
				}
			}
			return asbOption
		}

		async onSubmitLeadRefId() {
			let reqObj = {
				LeadRefID: this.state.leadRefIdValue,
				PFA_CODE: localStorage.getItem(QmsStorageKeys.AGENT_CODE),
				journeyId: this.props.location.state?.journeyId
			}

			let response = await QmsDetailsPageStore.getSAMSApi(reqObj)


			if (response?.data?.ResponseMsg === "Success") {

				if (response?.data?.Converted === "Yes") {
					AuthStore.setErrorModal(`This lead ${this.state.leadRefIdValue} is already converted, if it is second policy, please use add on lead feature in SAMS or else enter alternative leadid.`)
					this.setState({ disbledStartApplication: true })
					this.setState({ startAppLabel: { lead_ref_id: "", show_massage: false } });
				} else if (response?.data?.Converted === "No") {
					this.setState({ disbledStartApplication: false })
					this.setState({
						startAppLabel: { lead_ref_id: this.state.leadRefIdValue, show_massage: true }
					});
					this.setState({ leadRefIdValue: "" })
				}
			} else {
				this.setState({ disbledStartApplication: true })
				this.setState(prevState => ({
					startAppLabel: {
						...prevState.startAppLabel,
						show_massage: false
					}
				}));
				AuthStore.setErrorModal(response?.data?.ResponseMsg);
			}

		}

		render() {
			// console.log("QmsDetailsPageStore.solutionId ::: ",QmsDetailsPageStore.solutionId);
			console.log("localStorage.getItem(QmsStorageKeys.START_APPLICATION_END_POINT_URL) ::: ", localStorage.getItem(QmsStorageKeys.START_APPLICATION_END_POINT_URL));
			console.log("localStorage.getItem(QmsStorageKeys.LOGIN_AGENT_CODE) ::: ", localStorage.getItem(QmsStorageKeys.LOGIN_AGENT_CODE));
			console.log("REACT_APP_PRAGATI_START_APP_END_POINT ::: ", process.env.REACT_APP_PRAGATI_START_APP_END_POINT);
			let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
			let totalPayableAmount = SolutionStore.totalPayableAmount
			const coverageArray = this.state.seletedTabData?.coverage
			let details = toJS(SolutionStore.soluctionData)
			let familyProductDetailsId = toJS(SolutionStore.familyProductDetailsId)

			if (details <= 0 || coverageArray === undefined) return null
			let journeyId = this.props.location.state?.journeyId
			let proposerList = QmsDetailsPageStore.fetchTabListData(SolutionStore.user_list_data)
			let qmsDetailsData = SolutionStore.user_list_data
			let applicationDetails = QmsDetailsPageStore.seletedTabData;
			let sourceFrom = toJS(AuthStore.sourceFrom)
			console.log("sourceFrom ", sourceFrom)
			return (
				<Container className="solution-container qms-details-page">
					<Row>
						<Col xs="12">
							<QmsDetailsPageTabComponent
								tabList={proposerList}
								setSelectedTabIndex={this.setSelectedTabIndex}
							/>
						</Col>

						<Col xs="12">
							<Row className="mt-3">
								<Col lg="4" xs="12" className="pr-0  mt-3">
									<div className="d-flex">
										<div className="w-100 edit-quote">
											<NextButton
												buttonText="Edit Quote"
												size="sm"
												prefixIcon={<Image width='12' height='12' className="mr-2" src={images.QMSEditQuoteIcon} alt='back-arrow' />}
												onClick={() => this.onEditQuote()}
											/>
										</div>
										<div className="mx-3 w-100 start-application ">
											<NextButton buttonText="Start Application" onClick={() => {
												this.setState({ disbledStartApplication: true }),
													AuthStore.saveUserClicks(START_APPLICATION),
													QmsDetailsPageStore.startApplication(
														journeyId,
														applicationDetails?.solution_id
													)
											}}
												disabled={this.state.disbledStartApplication}
											/>

										</div>
									</div>
									{this.state.startAppLabel.show_massage &&
										<p className="start-app-label text-nowrap">Click on Start Application to proceed with {this.state.startAppLabel.lead_ref_id}</p>
									}
								</Col>

								<Col lg="5" xs="12" className="px-lg-0 mt-1 mt-lg-0">
									<Row className="mx-0 mx-md-1">
										{channel_code === "DIS" &&
											<>
												<Col lg="7" xs="12" className="p-0">
													<div className="flex flex-col w-100">
														<p className="mb-0 font-size-14">SAMS Lead ref id</p>
														<input
															type="text"
															className="w-100"
															value={this.state.leadRefIdValue}
															onChange={(e) =>
																this.setState({ leadRefIdValue: e.target.value })
															}
														></input>
													</div>
												</Col>
												<Col lg="5" xs="12" className="p-0">
													<div className=" w-100 lead-ref-submit-div">
														{this.state.leadRefIdValue.length > 0 &&
															<Button
																className=" w-100 lead-ref-submit text-center px-1 pt-1 ml-lg-2"
																onClick={this.onSubmitLeadRefId}
															>submit</Button>
														}
													</div>
												</Col>
											</>
										}
									</Row>
								</Col>

								<Col lg="3" xs="12" className="align-items-center d-flex justify-content-lg-end pr-4 mt-2 mt-lg-0">
									<div className="font-size-14 font-weight-400 mb-0 mr-1 download-pdf mt-md-0 mt-2 d-flex align-items-center" onClick={() => QmsDetailsPageStore.fetchPdfUrl(qmsDetailsData[0],sourceFrom)}>
										<Image className="mr-2" src={images.QMSPDFIcon} alt='back-arrow' />
										<span>{sourceFrom === "Distribution_App" ? "View Quote pdf" : "Download Quote pdf"}</span>
									</div>
								</Col>
								<Col lg="12" xs="12" className="align-items-center d-flex justify-content-lg-end mt-md-0 mt-2  pr-4 ">
									<img src={images.WhatsAppIcon} width={30} height={30} />
									<span className="text-nowrap send-pdf-whatsapp ml-2 font-size-15" onClick={() => this.checkPdfData()}>
										Share on WhatsApp
									</span>
									{QmsDetailsPageStore.showWspToolTip &&
										<>
											<div class="tooltip-share-pdf row">
												<div className="col-10  px-0 tooltip-text">
													Now Share Quote on WhatsApp
												</div>
												<div className="col-2 px-0">
													<Image
														className="close-icon-share-pdf"
														src={images.CloseIconBlack}
														onClick={() => { QmsDetailsPageStore.setShowWspToolTip(false) }}
													/>
												</div>

											</div>
										</>
									}
								</Col>
							</Row>
							<div className='border-bottom border-dark my-3'></div>
						</Col>
						<Col xs="12">
							<div className="d-flex">
								{this.state.seletedTabData?.solution_id && <p className="font-size-14 font-weight-bold mb-0 mr-1">Soln ID:{this.state.seletedTabData?.solution_id || '-'}</p>}
								<p className="font-size-14 mb-0">shared on {this.state.seletedTabData.pdf_shared_date ? moment(this.state.seletedTabData.pdf_shared_date).format("DD-MM-YYYY") : this.state.seletedTabData.pdf_shared_date}</p>
							</div>
						</Col>

						<Col xs="12">
							<CurrentCoverageCard
								selectedTabData={this.state.seletedTabData}
								totalPayableAmount={totalPayableAmount}
							/>
						</Col>

						<Col xs="12" md="12" lg="12" className="mt-5 mx-auto">
							<p className="text-primary font-weight-bold font-size-16 font-size-lg-18 mb-3 pb-0 pl-4">
								Solution Coverage
							</p>

							{details.map((item) => {

								if (item.laList.length >= 2) {
									return <SolutionScreenMulipleLaCard
										CardName={item.needTitle}
										detail={item}
									/>
								}
								return null

							})}

							<div className="row px-2 d-flex flex-column flex-lg-row  mt-2">
								{details.map((singleItem, index) => {
									if (singleItem.laList.length < 2) {

										return <SolutionScreenSingleLaCard
											key={index}
											CardName={singleItem.needTitle}
											detail={singleItem}
										/>
									}
									return null
								})}
							</div>
						</Col>

						{this.state.seletedTabData?.solutionBenifits &&
							<Col xs="12" className="mt-5 d-flex flex-column">
								<p className="text-primary font-weight-bold font-size-16 font-size-lg-18 mb-3 pb-0 pl-4">
									Solution Benefits
								</p>
								<div className="solution-card-col">
									<Row className="solution-mobile-bg-style">
										{this.state.seletedTabData?.solutionBenifits?.map((obj, index) => {
											return (
												<Col key={index} className="col-md-6 col-12 d-flex">
													<div className="solution-desktop-bg-style d-inline-block w-100 px-sm-3 pt-4 pt-lg-4 pb-lg-1">
														<SolutionBenefitsCard
															solutionData={obj}
														/>
													</div>
												</Col>
											)
										})}
									</Row>
								</div>
							</Col>
						}

						<Col
							xs="12"
							lg="12"
							className="protection-coverage-card-col my-5 mb-lg-5">
							<div className="d-flex align-items-center justify-content-between mb-1">
								<p className="text-primary font-weight-bold font-size-16 font-size-lg-18 mb-3 pb-0 pl-4">
									Solution Timeline
								</p>
								{this.showDownloadSampleBiBtn() && <UiButton className='font-size-14 font-size-lg-12 ml-1 font-weight-medium font-weight-lg-bold' variant='secondary' buttonText='Download Simplified Sample Cashflow' onClick={() => this.downloadSampleBi()} />}
							</div>
							{/* <PolicyTimlineTable data={this.state.seletedTabData || []} /> */}
							{!isObjectEmpty(QmsDetailsPageStore.solutionTimelineData) && <NewPolicyTimelineTableMultipleLa data={QmsDetailsPageStore.solutionTimelineData || []} />}
						</Col>

						<Col
							xs="12"
							lg="12"
							className="protection-coverage-card-col mb-4 mb-lg-5 d-flex flex-column"
						>
							<p className="text-primary font-weight-bold font-size-16 font-size-lg-18 mb-3 pb-0 pl-4">
								Underlying products
							</p>
							<div className="under-lying-card-container bg-white d-inline-block w-100 px-3 px-lg-3 pt-3 pb-1 pt-lg-4 mb-lg-0">
								{this.state.seletedTabData?.productList?.map((value, index) => (
									<UnderlyingCard key={index} productData={value} />
								))}
							</div>
						</Col>
					</Row>
					<StartApplicationModal
						journeyId={this.props.location.state?.journeyId}
						solutionId={QmsDetailsPageStore.solutionId}
					/>
					{QmsDetailsPageStore.showSharePdfmodal &&
						<SharePdf
							show={QmsDetailsPageStore.showSharePdfmodal}
						/>

					}
					{localStorage.getItem(QmsStorageKeys.LOGIN_AGENT_CODE) ? (
						<div>
							<form className='d-none' id='pragati-out-oubound-form-post-call' action={process.env.REACT_APP_PRAGATI_START_APP_END_POINT} method={"POST"}>
								<input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
								<input type='text' name='LoginCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_CODE)} />
								<input type='text' name='Vendor' value={localStorage.getItem(QmsStorageKeys.VENDOR)} />
								<input type='text' name='SourceFrom' value={localStorage.getItem(QmsStorageKeys.SOURCE_FROM)} />
								<input type='text' name='LoginAgentCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_AGENT_CODE)} />
								<input type='text' name='Solution_Id' value={QmsDetailsPageStore.solutionId ? QmsDetailsPageStore.solutionId : ""} />
								<input type='text' name='LA_Specific_Id' value={""} />
								<input type='text' name='IsWebAppHeader' value={sourceFrom === "Distribution_App" ? 'N' : 'Y' } />
								<button type='submit'>Submit</button>
							</form>
						</div>
					) : (
						<div></div>
					)}
				</Container>
			)
		}
	}
)

export default QmsDetailsPage
